import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import global from './modules/global' // Global state relevant for most/all pages
import courses from './modules/courses'
import preferences from './modules/preferences'
import units from './modules/units'
import plans from './modules/plans'
import userJourney from './modules/user-journey'
import savedCourse from './modules/saved-course'
import courseUpdates from './modules/course-updates'

Vue.use(Vuex)

export default new Vuex.Store({
   modules: {
      global,

      courses,
      preferences,
      units,
      plans,

      userJourney,
      savedCourse,
      courseUpdates
   },
   plugins: [new VuexPersistence({
      storage: window.sessionStorage,
      supportCircular: true,
      reducer: (state) => ({
         courses: state.courses,
         preferences: state.preferences,
         units: state.units,
         plans: state.plans,

         userJourney: state.userJourney,
         savedCourse: state.savedCourse})
   }).plugin]
})
